<div class="app-shell-container"
     [@fadeAnimation]="getRouterOutletState(o)">
  <router-outlet #o="outlet"></router-outlet>
</div>
